import { motion } from "framer-motion";
import {
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
  FaDownload,
} from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi";
import ProfilePic from "./ebin.png";

const stats = [
  { value: "10+", label: "Projects Finished" },
  { value: "1+", label: "Years of Experience" },
  { value: "15+", label: "Happy Clients" },
];

const socials = [
  { icon: <FaWhatsapp />, href: "https://wa.me/819036668177", label: "WhatsApp" },
  { icon: <FaEnvelope />, href: "mailto:ebinbenny055@gmail.com", label: "Gmail" },
  {
    icon: <FaInstagram />,
    href: "https://www.instagram.com/__ebi_____?igsh=MWtsdDNqcDR3eWE5eg==",
    label: "Instagram",
  },
  {
    icon: <FaLinkedinIn />,
    href: "https://www.linkedin.com/in/ebin-benny-18a37b3a5/",
    label: "LinkedIn",
  },
  {
    icon: <FaGithub />,
    href: "https://github.com/Zenitsucyberz",
    label: "GitHub",
  },
];

export default function Home() {
  return (
    <div className="relative min-h-screen flex items-center px-5 md:px-10 py-24 md:py-20">
      <div className="max-w-6xl mx-auto w-full grid md:grid-cols-2 gap-12 md:gap-8 items-center">
        {/* ================= LEFT: INTRO ================= */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          className="order-2 md:order-1 text-center md:text-left"
        >
          <span className="inline-block text-sm px-4 py-1.5 rounded-full glass text-violet-300 mb-5">
            👋 Hi, I'm
          </span>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight mb-3">
            <span className="grad-text">Ebin Benny</span>
          </h1>

          <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-200 leading-tight mb-5">
            A passionate Software Developer from Kerala, India
          </h2>

          <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0 mb-8">
            I build scalable web applications and modern user interfaces,
            specializing in{" "}
            <span className="text-gray-200">React, Laravel, Java & Spring Boot</span>.
            I blend clean design with solid engineering to deliver impactful
            digital products.
          </p>

          {/* Stats */}
          <div className="flex flex-wrap justify-center md:justify-start gap-6 sm:gap-10 mb-9">
            {stats.map((s) => (
              <div key={s.label} className="text-center md:text-left">
                <div className="text-2xl sm:text-3xl font-bold grad-text">
                  {s.value}
                </div>
                <div className="text-xs sm:text-sm text-gray-400 mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          {/* Buttons */}
          <div className="flex flex-wrap justify-center md:justify-start gap-4 mb-8">
            <a
              href="/Resume.pdf"
              download
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-violet-500 to-blue-500 font-semibold text-white shadow-lg shadow-violet-500/25 hover:scale-105 transition-transform"
            >
              <FaDownload /> Download CV
            </a>
            <a
              href="#portfolio"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl glass font-semibold text-gray-100 hover:border-violet-400/40 transition"
            >
              Explore My Projects <HiArrowRight />
            </a>
          </div>

          {/* Socials */}
          <div className="flex justify-center md:justify-start gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-11 h-11 flex items-center justify-center rounded-full glass text-gray-300 hover:text-white hover:bg-gradient-to-r hover:from-violet-500 hover:to-blue-500 transition"
              >
                {s.icon}
              </a>
            ))}
          </div>
        </motion.div>

        {/* ================= RIGHT: PHOTO ================= */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="order-1 md:order-2 flex justify-center"
        >
          <div className="relative">
            {/* glow */}
            <div className="absolute -inset-4 bg-gradient-to-tr from-violet-500/40 to-blue-500/40 blur-3xl rounded-full" />
            <img
              src={ProfilePic}
              alt="Ebin Benny"
              className="relative w-56 h-56 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-[26rem] lg:h-[26rem] object-cover rounded-3xl border border-white/10 shadow-2xl"
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
